<template>
  <div>
    <div >
      <el-row>
        <el-col :span="6" style="margin-left: 10px">
          <!--<el-card :body-style="{ padding: '0px' }" style="padding: 5px 5px 0 5px;text-align:center" >
              <el-input size="small" placeholder="请输入内容" v-model="auditionVideo.fileName">
                &lt;!&ndash;<template slot="append">&ndash;&gt;
                  &lt;!&ndash;<el-button type="primary" >.{{auditionVideo.extensionName}}</el-button>&ndash;&gt;
                &lt;!&ndash;</template>&ndash;&gt;
              </el-input>
                <el-button icon="el-icon-delete" size="mini" class="button" @click="deleteVideo(auditionVideo)" style="padding: 0; margin: 0; float: right;margin-bottom: 5px;"></el-button>
          </el-card>-->
          <div v-for="(auditionVideo,index)  in auditionVideoStrList" :key="index">
            <el-input
                class="input-new-tag"
                v-if="editable[index]"
                v-model="auditionVideo.fileName"
                :ref="'editableInput' + index"
                size="small"
                placeholder=""
                @keyup.enter.native="handleEditableInputConfirm(auditionVideo, index)"
                @change="handleEditableInputConfirm(auditionVideo, index)"
                @blur="handleEditableInputBlur(auditionVideo, index)"
                maxlength="20"
                show-word-limit
            ></el-input>
           
          <el-tag
              v-else
              :key="auditionVideo.fileId"
              closable
              :disable-transitions="false"
              @click="showEditTagInput(index,auditionVideo.fileId,auditionVideo.fileName,auditionVideo.filePath,auditionVideo.filePicture)"
              @close="deleteVideo(auditionVideo)">
              {{auditionVideo.fileName}}
          </el-tag>
          </div>
          <div >

          </div>
        </el-col>
        
        <el-col :span="3" >
          <div tabindex="0" v-if="auditionVideoStrList.length < 3" class="el-upload el-upload--picture-card" @click="choseFile" style="margin-left: 15px;">
            <i class="el-icon-plus"></i>
          </div>
        </el-col>
      </el-row>

      <div v-show="showfilepicture" class="showfilepicturecss" >
        <div class="showfilepicturebox" >修改信息</div>
        <!-- <div hidden><input type="text" ref="getValue0" v-model="fileIdup"/></div> -->
        <div class="showfilepicturecss1"  :id="fileIdup+'0'">视频名称:<input type="text" ref="getValue0" v-model="fileNameup"/></div>
        <div class="showfilepicturecss2"  :id="fileIdup+'4'" style="display: flex;">上传视频:
          <div class="updateavideo">        
            <el-form-item  prop="auditionTUpload">
            <el-upload
              v-model="auditionTUpload"
              name="upfile"
              style="margin-bottom: 10px;"
              class="upload-demo"
              :headers="myHeaders"
              :action="uploadURLP"
              :on-preview="handleauditionTUploadPreview"
              :on-remove="handleauditionTUploadRemove"
              :before-remove="beforeauditionTUploadRemove"
              :on-success="HandleauditionTUploadSuccess"
              multiple
              :limit="3"
              :on-exceed="handleauditionTUploadExceed"
              :file-list="auditionTUploadfileList">
              <el-button size="small" type="primary">上传视频</el-button>
            </el-upload>
        </el-form-item></div>

        </div>
        <div class="showfilepicturecss1"  :id="fileIdup+'1'">视频链接:<input type="text" ref="getValue1" v-model="filePathup"/></div>
        <div class="showfilepicturecss2"  :id="fileIdup+'2'">封面图:
        <el-form-item prop="filePicterup">
                  <el-upload
                      v-model="filePicterup"
                      name="upfile"
                      :action="uploadURLP"
                      :headers="myHeaders"
                      list-type="picture-card"
                      :on-remove="imagesHandleRemove"
                      :on-change="imagesOnChange"
                      :on-success="imagesEHandleSuccess"
                      :on-error="onError"
                      :before-upload="imagesBeforeAvatarUpload"
                      :limit="2"
                      :on-exceed="exceed"
                      :file-list="imagesEFileList"
                      :show-file-list="true"
                  >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
        </div>
        <el-form-item align="left">
          <el-button type="primary" size="small" @click="confirmFilePUpload()" class="but-cls">确定上传</el-button>
          <el-button type="primary" size="small" @click="cancelFilePUpload()" class="but-cls">取消修改</el-button>
        </el-form-item>
      </div>
    
    </div>
    
  
    <el-dialog
        title=""
        :visible.sync="showFileView"
        :close-on-click-modal=false
        style="width: 60%; min-height: 500px;"
        :before-close="handleClose"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        
        <!-- <el-tab-pane label="选取文件" name="first">
          <video controls="controls" :src="auditionVideo.filePath" id="aa" style="display: none" @canplaythrough="videoDuration(this)">
          </video>
          <el-upload
              :action="uploadURL"
              ref="auditionVideo"
              :on-preview="handleAutoCardPreview"
              :on-remove="auditionVideoHandleRemove"
              :on-change="auditionVideoOnChange"
              :on-success="auditionVideoHandleSuccess"
              :before-upload="auditionVideoBeforeAvatarUpload"
              :file-list="auditionVideoFileList"
              :show-file-list="true"
              :auto-upload="false"
              style="width: 50%"
          >
            <el-button slot="trigger" size="small" ref="selectFile" @click="uploadMethod(1)" type="primary">选取文件</el-button>
            <div v-show="uploadMethodData == 1">
              <div slot="tip" class="el-upload__tip">建议MP4格式，视频不宜太大</div>
              <el-progress :percentage="percent" status="success"></el-progress>
            </div>
          </el-upload>
          <el-button type="primary" size="small" @click="confirmUpload1()" :disabled="auditionVideo.fileId == null" class="but-cls">确定上传</el-button>
        </el-tab-pane> -->
        <el-tab-pane label="填写链接" name="second">
          <el-form enctype="multipart/form-data">
            <el-form-item label="视频名称:" prop="pathName">
              <el-input v-model="pathName" placeholder="视频名称" style="width: 70%; margin-bottom: 10px;" size="small"></el-input>
            </el-form-item>
            <el-form-item label="上传视频:" prop="auditionTryUpload">
                  <el-upload
                    v-model="auditionTryUpload"
                    name="upfile"
                    style="margin-bottom: 10px;"
                    class="upload-demo"
                    :headers="myHeaders"
                    :action="uploadURLP"
                    :on-preview="handleauditionTryUploadPreview"
                    :on-remove="handleauditionTryUploadRemove"
                    :before-remove="beforeauditionTryUploadRemove"
                    :on-success="HandleauditionTryUploadSuccess"
                    multiple
                    :limit="3"
                    :on-exceed="handleauditionTryUploadExceed"
                    :file-list="auditionTryUploadfileList">
                    <el-button size="small" type="primary">上传视频</el-button>
                  </el-upload>
                </el-form-item>
            <el-form-item label="视频链接:" prop="videoPath">
              <el-input v-model="videoPath" placeholder="视频链接" style="width: 70%; margin-bottom: 10px;" size="small"></el-input>
            </el-form-item>
            <!-- <el-form-item label="封 面 图:">
              <img src="" class="img-circle img-thumbnail img-responsive" id="avarimgs" width="30%">
              <input type="hidden" id="imageUrlFileUpload" value=""/>
              <input type="file"  @change="handleCoverFileUpload" accept="image/*" ref='boxFileUpload'>
            </el-form-item> -->
            <el-form-item label="封 面 图:" prop="fileImage">
                  <el-upload
                      v-model="fileImage"
                      name="upfile"
                      :action="uploadURLP"
                      :headers="myHeaders"
                      list-type="picture-card"
                      :on-preview="handleImagesCardPreview"
                      :on-remove="imagesHandleRemove"
                      :on-change="imagesOnChange"
                      :on-success="imagesHandleSuccess"
                      :on-error="onError"
                      :before-upload="imagesBeforeAvatarUpload"
                      :limit="2"
                      :on-exceed="exceed"
                      :file-list="imagesFileList"
                      :show-file-list="true"
                  >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogUVisible" size="tiny">
                <img width="100%" :src="dialogUImageUrl" alt="">
              </el-dialog>
            </el-form-item>
            <el-form-item align="center">
              <el-button type="primary" size="small" @click="confirmUpload()" class="but-cls">确定上传</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <canvas style="display: none" id="myCanvas"></canvas>
  </div>
</template>

<script>
  import Base64 from '@/api/video/lib/base64.js';
  import alioss from '@/api/video/ali-oss.js';
  import Crypto from 'crypto-js';
  import OSS from 'ali-oss';
  import AliPlayer from '@/components/AliPlayer/AliPlayer.vue';
  
  export default {
    name: '',
    components: {
      "ali-player": AliPlayer
    },
    props: {
      auditionVideoStrListTemp: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        myHeaders: {
          Authentication: localStorage.getItem("token")
          // Authorization
        },
        loginOrgCode: '',
        src: 'https://live.eblcu.cn/',
        version: 'player.v2.swf',
        _parm: '',
        isAutoStart: 'true',
        isOldAddress: 'true',
        activeName: 'second',
        showFileView: false,
        dialogUVisible: false,
        dialogUImageUrl: '',
        uploadURL: '',
        uploadURLP:'',
        isRtmp: false,
        auditionVideoFileList: [],
        uploadMethodDataType: 1,
        auditionVideoStrList: [],
        inputVisible: "",
        editable: [],
        inputValue: "",
        rtmpParam: {
          data: '',
          movie: ''
        },
        options: {
          img: '',                         //裁剪图片的地址
          info: true,                      //裁剪框的大小信息
          outputSize: 1,                   // 裁剪生成图片的质量
          outputType: 'jpeg',              //裁剪生成图片的格式
          canScale: false,                 // 图片是否允许滚轮缩放
          autoCrop: true,                  // 是否默认生成截图框
          autoCropWidth: 160,              // 默认生成截图框宽度
          autoCropHeight: 90,             // 默认生成截图框高度
          fixed: false,                    //是否开启截图框宽高固定比例
          fixedNumber: [16, 9]              //截图框的宽高比例
        },
        videoSrc: '',
        videoPath: '',
        pathName: '',
        fileImage:'',
        imagesFileList: [],
        imagesEFileList: [],
        percent: 0,
        uploadMethodData: 1,
        dialogAuditionVideo: false,
        hideAuditionVideoUpload: false,
        auditionVideo: {},
        percent: 0,
        video: {
          videoInfoId: '',
          videoInfoName: '',
          duration: '',
          bak2: ''
        },
        imgSrc: '',
        showfilepicture:false,
        fileIdup:'',
        fileNameup:'',
        filePathup:'',
        filePicterup:'',
        auditionTryUpload:'',
        auditionTryUploadfileList:[],
        auditionTUpload:'',
        auditionTUploadfileList:[],
      }
    },
    methods: {
      HandleauditionTUploadSuccess(response) {
        console.log(response.code,'response.code');
        this.auditionTUploadfileList = [];
        if(response.code == 200) {
          this.fileNameup = response.data.fileName;
          this.filePathup = response.data.resourceUrl;
          let file = {
          name: response.data.fileName,
          url: response.data.resourceUrl
          };
          this.auditionTUploadfileList.push(file);
          this.options.img = file.url;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
      },
      handleauditionTUploadRemove(file, fileList) {
        console.log(file, fileList);
      },
      handleauditionTUploadPreview(file) {
        console.log(file);
      },
      handleauditionTUploadExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeauditionTUploadRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }?`);
      },
      HandleauditionTryUploadSuccess(response) {
        console.log(response.code,'response.code');
        this.auditionTryUploadfileList = [];
        if(response.code == 200) {
          this.pathName = response.data.fileName;
          this.videoPath = response.data.resourceUrl;
          let file = {
          name: response.data.fileName,
          url: response.data.resourceUrl
          };
          this.auditionTryUploadfileList.push(file);
          this.options.img = file.url;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
      },
      handleauditionTryUploadRemove(file, fileList) {
        console.log(file, fileList);
      },
      handleauditionTryUploadPreview(file) {
        console.log(file);
      },
      handleauditionTryUploadExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeauditionTryUploadRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }?`);
      },
      onError () {
      },
      exceed(res, file) {
        console.log(res);
      },
      handleImagesCardPreview(file) {
        this.dialogUImageUrl = file.url;
        this.dialogUVisible = true;
      },
      imagesHandleRemove(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      imagesOnChange(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      imagesHandleSuccess(response, file, fileList) {
        console.log(response,'shifouzhixingle');
        this.imagesFileList = [];
        if(response.code == 200) {
          console.log(response,'responseresponse');
          this.fileImage = response.data.resourceUrl;
          let file = {
            name: response.data.fileName,
            url: response.data.resourceUrl
          };
          this.imagesFileList.push(file);
          this.options.img = file.url;
          this.isShowCropper = true;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
        
      },
      imagesEHandleSuccess(response, file, fileList) {
        console.log(response,'shifouzhixingle2');
        this.imagesEFileList = [];
        if(response.code == 200) {
          this.filePicterup = response.data.resourceUrl;
          let file = {
            name: response.data.fileName,
            url: response.data.resourceUrl
          };
          this.imagesEFileList.push(file);
          this.options.img = file.url;
          this.isShowCropper = true;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
        
      },
      imagesBeforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG/BMP 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        const isSize = new Promise(function(resolve, reject) {
          let width = 750;
          let height = 388;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width/img.height == 16/9;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          this.$message.error('上传图片尺寸必须为16:9!');
          return Promise.reject();
        });
        return isJPG && isLt2M && isSize;
      },
      handleCoverFileUpload(e) {
        let $target = e.target || e.srcElement
        let file = $target.files[0]
        let isImg = file.type == 'image/jpg' || file.type  == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/gif';
        if(!isImg){
          this.$message.error('操作失败：支持.jpg,.gif,.png格式');
          return;
        }
        let fileSizeLt2 = file.size/1024/1024 > 5 ;
        if(fileSizeLt2){
          this.$message.error('操作失败：图片最大5M');
          return;
        }
   
        var reader = new FileReader();
        reader.onload = function (e) {
          var img = document.getElementById("avarimgs");//获取图片id
          img.src = e.target.result;//给图片src路径赋值
          //重要：这里可以把获取的src路径的 base64 格式的图片传给后端即可
        }
        reader.readAsDataURL(file)

        let that = this;
        this.ajax("http://localhost:5020/app/anonymous/web/local_upload",file,function(res){
          console.log(res);
          if(res!=false){
            document.getElementById("imageUrlFileUpload").value=res;
          }
        })
      },

      handleCoverFilePUpload(e) {
        let $target = e.target || e.srcElement
        let file = $target.files[0]
        let isImg = file.type == 'image/jpg' || file.type  == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/gif';
        if(!isImg){
          this.$message.error('操作失败：支持.jpg,.gif,.png格式');
          return;
        }
        let fileSizeLt2 = file.size/1024/1024 > 5 ;
        if(fileSizeLt2){
          this.$message.error('操作失败：图片最大5M');
          return;
        }
   
        var reader = new FileReader();
        reader.onload = function (e) {
          var img = document.getElementById("avarimgspic");//获取图片id
          img.src = e.target.result;//给图片src路径赋值
          //重要：这里可以把获取的src路径的 base64 格式的图片传给后端即可
        }
        reader.readAsDataURL(file)
        let fileidid = this.fileIdup;
        let that = this;
        this.ajax("http://localhost:5020/app/anonymous/web/local_upload",file,function(res){
          console.log(res);
          if(res!=false){
            document.getElementById("file"+fileidid).value=res;
          }
        })
      },

      ajax(url,data,fn){
        const xhr =new XMLHttpRequest();
        xhr.onreadystatechange =function(){
          if(xhr.readyState ===4 && xhr.status ===200){
            fn(xhr.responseText);
          }
        }
        const formData=new FormData();
        formData.append('file',data);
        xhr.open("post",url,true);
        xhr.setRequestHeader("Authentication",localStorage.getItem("token"));
        xhr.send(formData);
      },

      choseFile() {
        this.showFileView = true;
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick((_) => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      cancelFilePUpload() {
        this.showfilepicture= false;
      },
      
      confirmFilePUpload() {
       let fileId = this.fileIdup;
       let pathName = this.fileNameup;
       console.log(pathName,'pathNamepathNamepathNamepathName');
       let path = this.filePathup;
       let filePicture = this.filePicterup;
        let params = {
          fileId:fileId,
          filePicture:filePicture,
          pathName: pathName,
          path: path,
        };
        console.log('params:',params);
        this.https.fetchPost('/file/update_upload_path', params, 'json').then((data) => {
          // let fileIdnew =data.data.data.fileId;
          this.showfilepicture= false;
          let code = data.data.code;
          // console.log(this.auditionVideoStrList,'old');
          // for (let i in this.auditionVideoStrList) {
          //     let oldfileid = this.auditionVideoStrList[i].fileId;
          //     if (oldfileid  == fileId) {
          //       this.auditionVideoStrList[i].fileId = fileIdnew;
          //     }
          // }
          console.log(this.auditionVideoStrList,'new');
          console.log(data.data,'data.datadata.datadata.data');
          let msg = data.data.msg;
          if (code == 200) {
            this.$message({
              type: 'success',
              message: '上传成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '上传失败:' + msg+ "0427"
            });
          }
        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );

      },
      showEditTagInput(index,fileid,fileName,filePath,filePicture) {
        this.imagesEFileList= [];
        this.fileIdup = fileid;
        console.log(this.fileIdup,'this.fileIdupnew');
        console.log(fileName,'fileName');
        this.fileNameup = fileName;
        this.filePathup = filePath;
        this.filePicterup = filePicture;
        let file = {
          'url':this.filePicterup
        };
        this.imagesEFileList.push(file);
        console.log(this.imagesEFileList,"this.imagesEFileList");
        this.showfilepicture = true;
        // this.$nextTick((_) => {
        //   var editableInput = "editableInput" + index;
        //   this.$refs[editableInput][0].$refs.input.focus();
        // });
      },
      handleEditableInputConfirm(item, index) {
        if (item.fileName) {
          this.$set(this.editable, index, false);
        } else {
          this.$message({ message: "请输入视频名称", type: "info" });
        }
      },
      handleEditableInputBlur(item, index) {
        this.$set(this.editable, index, false);
      },
      
      confirmUpload1() {
        this.showFileView = false;
        this.selectPlayer(this.auditionVideo);
        this.auditionVideoStrList.push(this.auditionVideo);
        this.auditionVideo = {};
        this.$refs.auditionVideo.clearFiles;
        this.$refs.auditionVideo.uploadFiles = [];
        this.percent = 0;
      },
      handleClick() {
      
      },
      handleTagClose() {
      
      },
      handleClose() {
        this.showFileView = false;
        this.auditionVideo = {};
        this.$refs.auditionVideo.clearFiles;
        this.$refs.auditionVideo.uploadFiles = [];
        this.percent = 0;
        this.pathName = "";
        this.videoPath = "";
      },
      videoDuration(ele) {
        let duration = document.getElementById('aa').duration;
        if(duration == null) {
          duration = 0;
        }
        this.video.duration = duration;
      },
      handleAutoCardPreview() {
        this.$refs.auditionVideo.clearFiles;
        this.percent = 0;
      },
      auditionVideoHandleRemove() {
      
      },

      multiError() { //上传失败
        console.log('上传失败,请重新上传', 'error');
      },
      auditionVideoOnChange(file, fileList) {
        console.log(this.auditionVideoStrList,'this.auditionVideoStrList');
        if(this.auditionVideoStrList.length>=5) {
          this.$message({
            type: 'info',
            message: '最多上传5个试听视频'
          });
          return;
        }
        let fileName = file.name;
        let extendName = fileName.substr(file.name.lastIndexOf('.') + 1);
        let videoName = fileName.substr(0, file.name.lastIndexOf('.'));
        if(this.loginOrgCode == 'blcuonline') {
          if (this.uploader) {
            this.uploader.stopUpload()
          }
          let userData = '{"Vod":{}}';
          this.uploader = this.createUploader();
          console.log(userData);
          this.uploader.addFile(file.raw, null, null, null, userData);
          if (this.uploader !== null) {
            this.uploader.startUpload()
          }
        } else {
          this.submitUpload();
        }

      },
      submitUpload() {
        let uploadFiles = this.$refs.auditionVideo.uploadFiles;
        if (uploadFiles.length != 1) {
          this.$refs.auditionVideo.uploadFiles.pop();
          this.$message({
            type: 'info',
            message: '只能上传一个试听视频'
          });
          return;
        }

        let file = uploadFiles[0].raw;
        let extendName = file.name.substr(file.name.lastIndexOf('.') + 1);
        let videoName = file.name.substr(0, file.name.lastIndexOf('.'));
        let fileSize = file.size;
        let params = {
          extendName: extendName,
          videoName: videoName
        };
        this.https.fetchPost('/file/getAuthorization', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.video.videoInfoId = data.data.data.videoInfoId;
            this.video.videoInfoName = data.data.data.videoName;
            this.video.bak2 = fileSize;
            this.uposs(data.data.data, file);
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );
      },
      auditionVideoHandleSuccess(response) {
        this.auditionVideoFileList = [];
        let file = {
          name: '123.png',
          url: response.data.filePath
        };
        this.auditionVideoFileList.push(file);
      },
      auditionVideoBeforeAvatarUpload(file) {
        let params = {
          extendName: 'mp4',
          videoName: '123'
        };
        // this.uposs(d,file);

        if(this.loginOrgCode == 'blcuonline') {
          if (this.uploader) {
            this.uploader.stopUpload()
          }
          let userData = '{"Vod":{}}';
          this.uploader = this.createUploader();
          console.log(userData);
          this.uploader.addFile(this.file, null, null, null, userData);
          /*if (this.uploader !== null) {
            this.uploader.startUpload()
          }*/
        } else {
          this.https.fetchPost('/file/getAuthorization', params, 'json').then((data) => {
            let code = data.data.code;
            if (code == 200) {
              this.video.videoInfoId = data.data.data.videoInfoId;
              this.uposs(data.data.data, file);
            } else {
              this.$message({
                type: 'info',
                message: '加载失败:' + msg
              });
            }

          }).catch(err => {
                this.$message.error('网络错误');
                console.log(err);
              }
          );
        }
        return false;
      },

      createUploader (type) {
        let self = this
        let uploader = new AliyunUpload.Vod({
          timeout:  60000,
          partSize:  1048576,
          parallel:  5,
          retryCount:  3,
          retryDuration:  2,
          region: 'cn-shanghai',
          userId: '10193998',
          // 添加文件成功
          addFileSuccess: function (uploadInfo) {
            console.log("addFileSuccess: " + uploadInfo.file.name)
          },
          // 开始上传
          onUploadstarted: function (uploadInfo) {
            // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
            // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
            // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
            // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
            // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
            let createUrl = '/videoInfo/getAliAuthorization';
            console.log(uploadInfo);
            let params = {
              videoFullName: uploadInfo.file.name,
              videoName: uploadInfo.file.name,
              type: 1
            };
            self.https.fetchPost('/videoInfo/getAliAuthorization', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                let response = data.data.data.response;
                let uploadAuth = response.uploadAuth
                let uploadAddress = response.uploadAddress
                let videoId = response.videoId
                uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId);
              } else {
                this.$message({
                  type: 'info',
                  message: '上传失败:' + msg
                });
              }
            }).catch(err => {
                  console.log(err);
                }
            );
            console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
            /*else {
              // 如果videoId有值，根据videoId刷新上传凭证
              // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
              let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
              axios.get(refreshUrl).then(({data}) => {
                let uploadAuth = data.UploadAuth
                let uploadAddress = data.UploadAddress
                let videoId = data.VideoId
                uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
              })
            }*/
          },
          // 文件上传成功
          onUploadSucceed: function (uploadInfo) {
            console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
            let params = {
              videoId:uploadInfo.videoId
            };
            self.https.fetchPost('/videoInfo/submitTranscodeJob', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                let fileId = data.data.data.fileId;
                let videoInfoId = data.data.data.videoInfoId;
                self.videoSrc = data.data.data.url;
                let video = {};
                self.$set(self.auditionVideo, "fileId", videoInfoId);
                self.$set(self.auditionVideo, "filePath", "");
                self.$set(self.auditionVideo, "fileName", uploadInfo.file.name);
                self.$set(self.auditionVideo, "extensionName", uploadInfo.file.name);
              } else {
                self.$message({
                  type: 'info',
                  message: '上传失败:' + msg
                });
              }
            }).catch(err => {
                  console.log(err);
                }
            );
          },
          // 文件上传失败
          onUploadFailed: function (uploadInfo, code, message) {
            console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message)
          },
          // 取消文件上传
          onUploadCanceled: function (uploadInfo, code, message) {
            console.log("Canceled file: " + uploadInfo.file.name + ", code: " + code + ", message:" + message)
          },
          // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
          onUploadProgress: function (uploadInfo, totalSize, progress) {
            console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%")
            let progressPercent = Math.ceil(progress * 100)
            self.percent = progressPercent
          },
          // 上传凭证超时
          onUploadTokenExpired: function (uploadInfo) {
            // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
            // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
            // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
            let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
            axios.get(refreshUrl).then(({data}) => {
              let uploadAuth = data.UploadAuth
              uploader.resumeUploadWithAuth(uploadAuth)
              console.log('upload expired and resume upload with uploadauth ' + uploadAuth)
            })
          },
          // 全部文件上传结束
          onUploadEnd: function (uploadInfo) {
            console.log("onUploadEnd: uploaded all the files");
          }
        })
        return uploader
      },
      
      uposs(obj, file) {
        var accesskey = obj.accesskeysecret;
        let key = obj.keyWord;
        var accessKeyId = obj.accesskeyid;
        var stsToken = obj.securitytoken;
        var videoInfoId = obj.videoInfoId;
        var urlfile = URL.createObjectURL(file);
        document.getElementById('aa').src = urlfile;
        var policyText = {
          'expiration': '2020-01-01T12:00:00.000Z', //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
          'conditions': [
            ['content-length-range', 0, 10485760000] // 设置上传文件的大小限制
          ]
        };

        var policyBase64 = Base64.Base64.encode(JSON.stringify(policyText));
        var message = policyBase64;
        var bytes = Crypto.HmacSHA1(message, accesskey);
        let signature = bytes.toString(Crypto.enc.Base64);


        let ossClient = new OSS({
          'region': 'oss-cn-beijing',
          'accessKeyId': accessKeyId, //1111
          'accessKeySecret': accesskey,
          'stsToken': stsToken, //1111
          'bucket': 'openbj',
          'endpoint': 'https://oss-cn-beijing.aliyuncs.com',
          'policy': policyBase64,
          'success_action_status': '200', //让服务端返回200,不然，默认会返回204
          'signature': signature
        });

        let abort = false; //进度条显示
        let checkpoint_temp = true;
        let result = alioss.multitest(ossClient, file, checkpoint_temp, this.multiSuccess, '', this.uploadProgress, key);

      },
      multiSuccess(result) {
        if (result) {
          if (result.res.status == 200) {
            let params = {
              videoInfoId: this.video.videoInfoId,
              videoInfoName: this.video.videoInfoName,
              bak2: this.video.bak2,
              duration: parseInt(this.video.duration)
            };
            this.https.fetchPost('/file/saveVideoPlayUrl', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.videoSrc = data.data.data.url;
                let video = {};
                this.$set(this.auditionVideo, "fileId", data.data.data.videoInfoId);
                this.$set(this.auditionVideo, "filePath", data.data.data.url);
                this.$set(this.auditionVideo, "fileName", data.data.data.videoName);
                this.$set(this.auditionVideo, "extensionName", data.data.data.extensionName);
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
              }

            }).catch(err => {
                  this.$message.error('网络错误');
                  console.log(err);
                }
            );
          }
        }
      },
      uploadProgress(percent) {
        this.percent = percent * 100;
      },
      uploadMethod(val) {
        this.uploadMethodData = val;
      },
      videoDuration(ele) {
        let duration = document.getElementById('aa').duration;
        this.video.duration = duration;
      },
      parm(url, mediaURL) {
        this._parm = '?';
        this._parm += 'url=' + url + '&&';
        this._parm += 'filename=' + mediaURL + '&&';
        this._parm += 'isAutoStart=' + this.isAutoStart + '&&';
        this._parm += 'isOldAddress=' + this.isOldAddress + '&&';
      },
      confirmUpload() {
        if (this.videoPath == '') {
          this.$message({
            type: 'info',
            message: '视频链接不能为空！'
          });
          return;
        }
      
        let params = {
          filePicture:this.fileImage,
          pathName: this.pathName,
          path: this.videoPath
        };
        this.https.fetchPost('/file/upload_path', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            console.log(data.data);
            this.$set(this.auditionVideo, "fileId", data.data.data.fileId);
            this.$set(this.auditionVideo, "filePath", data.data.data.filePath);
            this.$set(this.auditionVideo, "fileName", data.data.data.fileName);
            this.selectPlayer(this.auditionVideo);
            this.showFileView = false;
            this.auditionVideoStrList.push(this.auditionVideo);
            this.$message({
              type: 'success',
              message: '上传成功'
            });
            this.auditionVideo = {};
            this.pathName = "";
            this.videoPath = "";
          } else {
            this.$message({
              type: 'info',
              message: '上传失败:' + msg+ "0427ly"
            });
          }
        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );

      },
      deleteVideo(vodeo) {
        this.auditionVideoStrList.splice(this.auditionVideoStrList.indexOf(vodeo), 1);
        
      },
      //截取视频第一帧作为播放前默认图片
      findvideocover(url) {
        const  video = document.getElementById("aa");
        video.src=url // url地址 url跟 视频流是一样的
        var canvas = document.getElementById('myCanvas');
        const ctx = canvas.getContext('2d');
        video.crossOrigin = 'anonymous';
        video.currentTime = 1;
        video.oncanplay = () => {
          canvas.width = video.clientWidth; // 获取视频宽度
          canvas.height = video.clientHeight; //获取视频高度
          ctx.drawImage(video, 0, 0, canvas.width,canvas.height)
          this.imgsrc = canvas.toDataURL("image/png");
          this.auditionVideo.imgSrc = this.imgsrc;
          console.log(this.imgsrc);
        }
      },
      selectPlayer(video) {
        let url = video.filePath;
        if(!url) {
          return;
        }
        this.$set(video, "isRtmp", false)
        if (url.indexOf('rtmp:') >= 0) {
          this.$set(video, "isRtmp", true)
          let urls = url.split('/mp4:');
          let url1 = urls[0];
          let mediaURL = urls[1];
          this.parm(url1, mediaURL);
          // data this.src+this.getVersion()+this.parm()
          let rtmpParam = {};
          rtmpParam.data = this.src + this.version + this._parm;
          rtmpParam.movie = this.src + this.version + this._parm;
          video.rtmpParam = rtmpParam;
        }
      },
      selectCommodityDetailP(commodityId) {
        let params = {
          commodityId: commodityId
        };
        this.https.fetchPost('/commodityInfo/getByCommodityId', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.form = data.data.data;     
            console.log(data.data.data,'data.data.datadata.data.data');   
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }
        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
    },
    created: function() {
      this.loginOrgCode = this.$store.state.orgCode;
      this.uploadURL = this.https.baseURL + '/file/fdfs_upload';
      this.uploadURLP = this.https.baseURL + '/resources/updateResourceFile';
    },
    
    watch: {
      auditionVideoStrList:  {
        handler: function(newV,oldV) {
          this.$emit('changeAuditionVideoStrList', this.auditionVideoStrList);
         
        },
        deep: true
      },
      auditionVideoStrListTemp:  {
        handler: function(newV,oldV) {
          if(newV) {
            console.log(newV,'newVnewVnewV');
            this.auditionVideoStrList = newV;
          }
        },
        deep: true
      },
    }
  };
</script>

<style scoped >
  .el-col-6 {
    width: 40%;;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog{
    position: absolute;
    top:50%;
    left:50%;
    margin:0 !important;
    transform:translate(-50%, -50%);
    max-height:calc(100% - 30px);
    max-width:calc(100% - 30px);
    display:flex;
    flex-direction:column;
  }
  .el-dialog__body{
    overflow:auto
  }
  .el-dialog__wrapper{
    margin-left:auto;
    margin-right:auto;
  }
.auditionVideoUpdate {
    width:270px;
    height:auto;
    background: #ecf5ff;
    border: #d9ecff;
  }
  .el-tag {
    /* display: block; */
    position: relative;
    cursor:pointer;
  }
  .showfilepicturecss {
    width: 60%;
    height: auto;
    background: #f8f5f5;
    padding-left: 20px;
    padding-bottom: 20px;;
  }
  .showfilepicturecss1 {
    color: #409EFF;
  }
  .showfilepicturecss1 input {
    width: 65%;
    height: 25px;
    border-color: #d9ecff;
    outline: none;
    margin-left: 10px;
    padding-left: 10px;
  }
  .showfilepicturecss2 .updateavideo {
    width: 65%;
    margin-left: 10px;
    padding-left: 10px;
  }
  .showfilepicturecss2 {
    color: #409EFF;
  }
  .showfilepicturebox {
    width: fit-content;
    height: 25px;
    color: rgb(207, 39, 39);
    margin-bottom: 20px;
  }
  
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 60%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  .ql-snow .ql-picker.ql-lineheight {
    width: 70px;
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-label::before {
    content: '行高';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='initial']::before {
    content: '默认';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1']::before {
    content: '1';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.5']::before {
    content: '1.5';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.75']::before {
    content: '1.75';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='2']::before {
    content: '2';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='3']::before {
    content: '3';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='4']::before {
    content: '4';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='5']::before {
    content: '5';
  }
  .el-tag{
    cursor: pointer;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .el-table th {
   padding: 0;
  }
  .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
    padding-left: 0;
  }
  .el-table .cell, .el-table th div {
    padding-right: 0;
  }
</style>